import React, { useState, useEffect } from "react";
import {
    IconButton,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Box
} from "@mui/material";
import { PublishedWithChanges as RotateKeyIcon } from "@mui/icons-material";
import { useData } from "@pure-ptr/react";
import { rotateApiKey } from "../../../../store/api/apikey";
import { Loadable } from "../../../../common";
import { errorToastify } from "../../../../util/toast";
import CopyIcon from "@mui/icons-material/FileCopyOutlined";

const style = {
    fontWeight: "bold",
    width: "85px",
    display: "inline-block",
};

export const APKeysRotationDialog = ({ classes, rowData,handleRefresh }) => {
    const [open, setOpen] = useState(false);
    const [apiKeyId, setApiKeyId] = useState(null);
    const [isCopied, setCopied] = useState(false);

    const {
        data: rotationResponse,
        isPending: rotatingApiKey,
        error,
    } = useData(async () => {
        if (!apiKeyId) return;
        setApiKeyId(null);
        const rotationResponse = await rotateApiKey(apiKeyId);
        return rotationResponse;
    }, [apiKeyId]);

    const handleClose = () => {
        if(rotationResponse?.newKeyValue)
        {
            handleRefresh()
        }
        setOpen(false);
    };

    useEffect(() => {
        if (!error) return;
        setApiKeyId(null);
        errorToastify(
            error?.payload?.error ||
                error?.payload?.message ||
                "Something Went Wrong !!!"
        );
    }, [error]);

    const handleCopyIcon = (apiKey) => {
        navigator.clipboard.writeText(apiKey);
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 3000);
    };

    return (
        <>
            <IconButton
                color="primary"
                className={classes.IconButton}
                aria-label="Active"
                onClick={() => setOpen(true)}
                size="large"
            >
                <Tooltip title="Rotate Api Key">
                    <RotateKeyIcon sx={{ color: "gray", fontSize: "22px" }} />
                </Tooltip>
            </IconButton>

            <Dialog open={open} onClose={handleClose}>
                <Loadable loading={rotatingApiKey !== null}>
                    <DialogTitle>
                        {rotationResponse?.newKeyValue
                            ? "Refreshed API KEY"
                            : `Are you sure ?`}
                    </DialogTitle>

                    <DialogContent>
                        {rotationResponse?.newKeyValue ? (
                            <>
                            <Typography>
                                <Box sx={{...style}} component='span'>API KEY: &nbsp;</Box> {rotationResponse?.newKeyValue}
                                <IconButton
                                    className="p-1 ml-2"
                                    aria-label="toggle api key visible"
                                    onClick={()=>handleCopyIcon(rotationResponse?.newKeyValue )}
                                    color={isCopied ? "secondary" : "primary"}
                                    size="large"
                                >
                                    <CopyIcon />
                                </IconButton>
                            </Typography>
                            <Typography>
                                <Box sx={{...style}} component='span'>Expiry Date: &nbsp;</Box> {rotationResponse?.newExpireDate}
                            </Typography>


                            </>
                        ) : (
                            `Are you sure you want to refresh this API Key ?`
                        )}
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose}>{rotationResponse?.newKeyValue ?"Close":"Cancel"}</Button>
                        {!rotationResponse?.newKeyValue && (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setApiKeyId(rowData?.id)}
                            >
                                Confirm
                            </Button>
                        )}
                    </DialogActions>
                </Loadable>
            </Dialog>
        </>
    );
};
